export const SIMPLE_IMAGE_EDITOR_CONSTS = {
  titleMsg: 'Вставка фото',
  okLabelMsg: 'Сохранить',
  addPhotoMsg: 'Вставить фото',
  cancelMsg: 'Отмена',
  setAnotherPhotoLabelMsg: 'Установить другое фото',
  warningMsg: 'Внимание!',
  closeConfirmBtn: 'Да, выйти',
  backConfirmationText: 'Внесенные измененения не будут сохранены. Вы уверены, что хотите выйти?',
  imageForMobileTitle: 'Обложка для мобильной версии',
  viewSourceImage: 'Посмотреть исходник'
}
